import React from "react"
import styled from "styled-components"
import isMobile from "is-mobile"
import { View } from "./"

const size = 1.76

export default styled(View).attrs(() => ({ color: "border" }))`
  position: relative;
  top: -4px;
  width: ${size}rem;
  height: ${size}rem;
  background: transparent;
  border: 0;

  :before,
  :after {
    position: absolute;
    left: ${size / 2}rem;
    content: " ";
    height: ${size}rem;
    width: 1px;
    background-color: currentColor;
    transform-origin: center center;
  }
  :before {
    transform: rotate(45deg);
  }
  :after {
    transform: rotate(-45deg);
  }
  :hover {
    opacity: 0.6;
  }
  transition: opacity 250ms ease;
  cursor: pointer;
  z-index: 999;
`
